﻿import $ from 'jquery';
import "../../modules/popover";
import { IPopOverHTMLElement } from '../../modules/popover';
import { FormValidation } from "./formvalidation";

export class ErrorPopover {
  private defaults = {
    channel: 'error',
    placement: 'top',
    containerClass: 'error-container',
    position: 'element',
    sizing: 'element',
    mode: 'copy'
  };

  private options;

  constructor(popoverOptions = {}) {
    this.options = $.extend({}, this.defaults, popoverOptions);
  }

  public append($targetInput: JQuery, targetId: string, message: any, trigger?: string, clearErrorOptions?: IClearErrorOptions): void {
    this.addValidationClass($targetInput);
    trigger = trigger || 'focus'

    // create popover content
    var $popover = $('<div data-popover-content="' + targetId + '">');
    var $content = $('<div class="error-popover popover">');

    var $existingPopover = $('[data-popover-content="' + targetId + '"]');
    if ($existingPopover.length != 0)
      $existingPopover.remove();

    $(document.body).append($popover);
    $popover.append($content);
    $content.append(message);

    // init popover
    $targetInput.popover({
      popover: targetId,
      trigger: trigger,
      ...this.options
    });

    let resultClearErrorOptions = this.determineClearErrorBehavior($targetInput, clearErrorOptions);
    let self = this;
    resultClearErrorOptions.clearErrorWireups.forEach((x) => {
      x.$targetInput.on(x.triggerEvents, function (e) {
        if (x.$targetInput.data('r-is-constructing') as boolean) {
          return true;
        }

        self.removeErrorState(x.$targetInput, resultClearErrorOptions.onErrorPopoverDisabled);
        return true;
      });
    });
  }

  protected addValidationClass($target: JQuery):void {
    $target.addClass(FormValidation.validationClass);
  }

  private determineClearErrorBehavior($defaultTarget: JQuery, options?: IClearErrorOptions): IClearErrorOptions {
    let result = $.extend({}, this.defaultClearErrorBehavior($defaultTarget), options);

    return result;
  }

  private removeErrorState($target: JQuery, onErrorPopoverDisabled?: Function): void {
    $target.removeClass(FormValidation.validationClass);
    let $popoverElement = ($target[0] as IPopOverHTMLElement);

    if ($popoverElement?.popovers) {
      $popoverElement.popovers['error'].disable();
    }

    if (onErrorPopoverDisabled) {
      onErrorPopoverDisabled();
    }
  }

  private defaultClearErrorBehavior($target:JQuery): IClearErrorOptions
  {
    let defaultWireups: IClearErrorWireup[] = [this.defaultWireup($target)];

    return {
      clearErrorWireups: defaultWireups,
      onErrorPopoverDisabled: null
    };
  };

  private defaultWireup($target: JQuery): IClearErrorWireup {
    return {
      $targetInput: $target,
      triggerEvents: 'change change.rustig input'
    };
  }
}

export interface IClearErrorOptions {
  clearErrorWireups?: Array<IClearErrorWireup>;
  onErrorPopoverDisabled?: Function;
}

export interface IClearErrorWireup {
  $targetInput: JQuery;
  triggerEvents: string;
}